import { Box, BoxProps } from "@chakra-ui/react";
import { cn } from "@peerigon/pupper/tailwind";

/**
 * DatoCMS sanitizes multiline field content for us,
 * since we only use that content with dangerouslySetInnerHTML, we can
 * safely ignore eslint's warning here.
 */

export const DatoRichTextContent = ({
	html,
	...props
}: BoxProps & { html: string }) => {
	const { className, ...rest } = props;

	return (
		<Box
			dangerouslySetInnerHTML={{ __html: html }}
			className={cn("[&>ul]:list-disc", className)}
			{...rest}
		/>
	);
};

// 🔬 TBD: Please evaluate
